import Vue from 'vue';
import DragAndDropPreview from '../components/DragAndDropPreview.vue';
const Preview = Vue.extend(DragAndDropPreview);
let preview;
/**
 *
 * @param nodes
 */
export async function getDragAndDropPreview(nodes) {
    return new Promise((resolve) => {
        if (!preview) {
            preview = new Preview().$mount();
            document.body.appendChild(preview.$el);
        }
        preview.update(nodes);
        preview.$on('loaded', () => {
            resolve(preview.$el);
            preview.$off('loaded');
        });
    });
}
